import { IntlProvider } from 'react-intl';
import useMessages from 'hooks/use_messages';
import { useLocale } from 'contexts/locale';

const Intl = ({ children }) => {
  const { locale } = useLocale();
  const messages = useMessages();

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};

export default Intl;
